import { Box, Button, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { useMessage, useTranslation } from '@/core'
import { captureError } from '@/core/errors'

export type DeleteFavoriteMemberModalProps = {
  open: boolean
  onClose: () => void
  onDelete: (memberId: string) => Promise<void>
  memberId: string
  memberName: string
}

export const DeleteFavoriteMemberModal: FC<DeleteFavoriteMemberModalProps> = ({
  open,
  onClose,
  onDelete,
  memberId,
  memberName,
}) => {
  const { t } = useTranslation('consoleFavoriteMemberSettings')
  const { showMessage } = useMessage()
  const [loading, setLoading] = useState(false)

  const handleDelete = async () => {
    setLoading(true)
    return onDelete(memberId)
      .then(() => {
        showMessage(t('completeRemoveMember'))
        onClose()
      })
      .catch(e => {
        captureError(e, 'consoleFavoriteMemberDelete')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('deleteMemberModalTitle')}
      innerSx={{
        width: 300,
      }}
      content={
        <>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: 13,
              fontWeight: 300,
            }}
          >
            {t('removeMemberDescription', { memberName })}
          </Typography>

          <Box sx={{ mt: 4 }}>
            <Button
              color="primary"
              size="large"
              fullWidth
              onClick={handleDelete}
              loading={loading}
              disabled={loading}
            >
              {t('removeMember')}
            </Button>
          </Box>
          <Box sx={{ mt: 2 }}>
            <Button variant="text" onClick={onClose}>
              {t('cancel')}
            </Button>
          </Box>
        </>
      }
    />
  )
}
